<template>
  <section class="month-calendar__wrapper">
    <div class="onboarding-modal__input-wrapper">
      <div class="manage__input-wrapper">
        <select
          v-model="monthSelected"
          class="month-calendar__select onboarding-modal__input onboarding-modal__select"
          @change="calendarDays($event)"
        >
          <option
            v-for="month in months"
            :key="`month-${month.name}`"
            :value="month.number"
            >{{ month.name }}</option
          >
        </select>
        <ChevronDownIcon
          class="onboarding-modal__select-icon month-calendar__select-icon"
        />
      </div>
    </div>
    <div class="month-calendar__calendar">
      <div
        v-for="(day, dayIndex) in currentCalendarDays"
        :key="`day-${dayIndex}`"
        @click="setCurrentDay(day, dayIndex)"
        class="month-calendar__calendar-day-wrapper"
      >
        <div
          :class="[
            'month-calendar__calendar-day ',
            isDayDisabled(dayIndex) && 'month-calendar__calendar-day--disabled',
            isDaySelected(day) &&
              !isDayDisabled(dayIndex) &&
              'month-calendar__calendar-day--selected',
          ]"
        >
          {{ day }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CONSTANTS from '@/constants'
import { ChevronDownIcon } from 'vue-feather-icons'

export default {
  name: 'MonthCalendar',
  components: {
    ChevronDownIcon,
  },
  props: {
    birthdate: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      monthSelected: 1,
      currentDay: 1,
      months: CONSTANTS.YEAR_MONTHS,
      totalDays: 35,
      currentCalendarDays: [],
      lastMonthDays: 0,
      isLoading: false,
    }
  },
  computed: {
    getCurrentMonth() {
      return CONSTANTS.YEAR_MONTHS.find(
        month => month.number === this.monthSelected
      )
    },
  },
  methods: {
    calendarDays(event) {
      this.monthSelected = Number(event?.target?.value || this.monthSelected)
      const currentMonth = this.getCurrentMonth
      const totalDays = this.totalDays
      const currentMonthDays = currentMonth.days
      const lastMonthNumber =
        currentMonth.number === 1 ? 12 : currentMonth.number - 1
      const lastDayOfLastMonth = CONSTANTS.YEAR_MONTHS[lastMonthNumber - 1].days
      const lastMonthDays =
        lastDayOfLastMonth - (totalDays - currentMonthDays) + 1
      this.lastMonthDays = lastDayOfLastMonth - lastMonthDays
      this.currentCalendarDays = _.range(
        lastMonthDays,
        lastDayOfLastMonth + 1
      ).concat(_.range(1, currentMonthDays + 1))
      this.sendCurrentDate()
    },

    setCurrentDay(day, dayIndex) {
      if (this.isDayDisabled(dayIndex)) return
      this.currentDay = day
      this.sendCurrentDate()
    },
    isDayDisabled(dayIndex) {
      return dayIndex < this.totalDays - this.getCurrentMonth?.days
    },
    isDaySelected(day) {
      return day === this.currentDay
    },
    sendCurrentDate() {
      this.$emit('calendar-current-date', {
        birth_month: this.monthSelected,
        birth_day: this.currentDay,
      })
    },
  },
  created() {
    this.currentDay = this.birthdate?.birth_day
    this.monthSelected = this.birthdate?.birth_month
    if (!this.birthdate) this.sendCurrentDate()
    this.calendarDays()
  },
}
</script>

<style lang="scss" scoped>
.month-calendar {
  &__wrapper {
    margin-bottom: 28px;
    & .onboarding-modal__input-wrapper {
      width: 100%;
      max-width: 100%;
    }
  }
  &__select {
    height: 38px;
    padding: 0 11px;
    @include mobile {
      height: 46px;
    }
    &-icon {
      top: 8px;
      @include mobile {
        top: 12px;
      }
      @include tablet {
        top: 16px;
      }
    }
  }
  &__calendar {
    display: flex;
    flex-wrap: wrap;
    color: var(--light-blue-gray);
    margin-top: 20px;
    width: 110%;
    margin-left: -5%;
  }
  &__calendar-day-wrapper {
    flex: 1 1 14.28%;
    margin-bottom: 4px;
    justify-content: center;
    display: flex;
  }
  &__calendar-day {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: rem(12);
    line-height: 14px;
    width: 24px;
    height: 24px;
    cursor: pointer;
    @include mobile {
      font-size: rem(18);
      line-height: 21px;
      width: 40px;
      height: 40px;
    }
    @include tablet {
      font-size: rem(15);
      line-height: 18px;
      width: 32px;
      height: 32px;
    }
    &:hover:not(.month-calendar__calendar-day--disabled),
    &--selected {
      border-radius: 50%;
      border: 1px solid var(--melrose);
      color: var(--concrete);
      background: var(--glass-dark);
    }
    &--disabled {
      color: var(--dove-gray);
      cursor: initial;
    }
  }
}
</style>
